import { useQuery } from "@apollo/client";
import { FiPlus } from "react-icons/fi";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import Errors from "components/base/Errors";
import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { FETCH_ALL_CATALOGS } from "./graphql";
import CatalogCard from "./CatalogCard";
import CatalogFormModal from "./CatalogFormModal";

function CatalogPage() {
  const { loading, error, data, refetch } = useQuery(FETCH_ALL_CATALOGS);
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const catalogs = data?.allCatalogs || [];

  const handleCreateCatalog = () => {
    modal.present({
      maxWidth: "max-w-3xl",
      center: true,
      children: <CatalogFormModal refetch={refetch} hide={modal.hide} />,
    });
  };

  return (
    <Page
      title="Catalogs"
      rightButtons={
        <Button onClick={handleCreateCatalog}>
          <span className="flex items-center">
            <FiPlus className="mr-2" />
            Create Catalog
          </span>
        </Button>
      }
    >
      <div className="m-6">
        <div className="opacity-70 space-y-2">
          <p>
            Please directly click the button on the top right to upload
            catalogs.
          </p>
        </div>
      </div>

      <div className="my-6 flex-1">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {catalogs.map((cat) => (
              <CatalogCard cat={cat} key={cat.id} refetch={refetch} />
            ))}
          </div>
        </div>
      </div>
    </Page>
  );
}

export default CatalogPage;
